import { CountryEnum } from 'shared/enums/country-enum'
import { LocaleEnum, getLanguageCodeByLocale } from 'shared/enums/locale-enum'

const countries = require('i18n-iso-countries')
countries.registerLocale(require('i18n-iso-countries/langs/en.json'))

export interface CountryDataInterface {
  id: string
  caption: string
}

export const getCountryData = (locale?: LocaleEnum): CountryDataInterface[] => {
  const availableLocales = Object.values(LocaleEnum)

  if (locale && availableLocales.includes(locale)) {
    countries.registerLocale(
      require(`i18n-iso-countries/langs/${getLanguageCodeByLocale(locale)}.json`),
    )
  } else {
    countries.registerLocale(
      require(`i18n-iso-countries/langs/${getLanguageCodeByLocale(LocaleEnum.ENGLISH)}.json`),
    )
  }

  return Object.keys(CountryEnum).map(el => {
    const key = el as keyof typeof CountryEnum
    return {
      id: CountryEnum[key],
      caption: countries.getName(CountryEnum[key], locale || 'en'),
    }
  })
}
